"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketErrorCodeTitles = exports.SocketErrorCodes = exports.SocketEvents = void 0;
var SocketEvents;
(function (SocketEvents) {
    SocketEvents["SetupConnection"] = "setup-connection";
    SocketEvents["SetupError"] = "setup-error";
    SocketEvents["SetupSuccess"] = "setup-success";
    SocketEvents["Connect"] = "connect";
    SocketEvents["Disconnect"] = "disconnect";
    SocketEvents["StartUpload"] = "start-upload";
    SocketEvents["UploadSuccess"] = "upload-success";
    SocketEvents["UploadError"] = "upload-error";
    SocketEvents["FileChunk"] = "file-chunk";
    SocketEvents["FinishUpload"] = "finish-upload";
    SocketEvents["UploadProgress"] = "upload-progress";
    SocketEvents["CancelUpload"] = "cancel-upload";
    SocketEvents["UploadCancelled"] = "upload-cancelled";
    SocketEvents["AIGenerate"] = "generate";
    SocketEvents["AIGenerationEnd"] = "generation-end";
    SocketEvents["AIError"] = "ai-error";
    SocketEvents["FileSummarize"] = "file-summarize";
    SocketEvents["FileSummarizeSuccess"] = "file-summarize-success";
    SocketEvents["FileSummarizeError"] = "file-summarize-error";
    SocketEvents["ReportChatQuestion"] = "report-chat-question";
    SocketEvents["ReportChatError"] = "report-chat-error";
    SocketEvents["McpToolCallPending"] = "mcp-tool-call-pending";
    SocketEvents["McpToolCallResponse"] = "mcp-tool-call-response";
    SocketEvents["McpToolCallResult"] = "mcp-tool-call-result";
    SocketEvents["UserAuth"] = "user-auth";
    SocketEvents["UserError"] = "user-error";
})(SocketEvents || (exports.SocketEvents = SocketEvents = {}));
var SocketErrorCodes;
(function (SocketErrorCodes) {
    SocketErrorCodes[SocketErrorCodes["BadRequest"] = 1] = "BadRequest";
    SocketErrorCodes[SocketErrorCodes["Unauthorized"] = 2] = "Unauthorized";
    SocketErrorCodes[SocketErrorCodes["ProviderRelatedError"] = 3] = "ProviderRelatedError";
    SocketErrorCodes[SocketErrorCodes["InternalServerError"] = 999] = "InternalServerError";
})(SocketErrorCodes || (exports.SocketErrorCodes = SocketErrorCodes = {}));
exports.SocketErrorCodeTitles = {
    [SocketErrorCodes.BadRequest]: "Bad Request",
    [SocketErrorCodes.Unauthorized]: "Unauthorized",
    [SocketErrorCodes.ProviderRelatedError]: "Provider Related Error",
    [SocketErrorCodes.InternalServerError]: "Internal Server Error",
};
